import { readBuffery45c0omfxhxc as readBuffer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readBuffer(_this__u8e3s4.a5k().n5m(), $completion));
  return SavedHttpCall().w5n(_this__u8e3s4.v5j_1, _this__u8e3s4.y5l(), _this__u8e3s4.a5k(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, request, response, responseBody) {
        return new.target.w5n(client, request, response, responseBody);
      }
      static w5n(client, request, response, responseBody) {
        var $this = this.x5l(client);
        $this.u5n_1 = responseBody;
        $this.x5j_1 = new (SavedHttpRequest())($this, request);
        $this.y5j_1 = new (SavedHttpResponse())($this, $this.u5n_1, response);
        checkContentLength(contentLength(response), fromInt($this.u5n_1.length), request.g5m());
        $this.v5n_1 = true;
        return $this;
      }
      a5m() {
        return this.v5n_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.x5n_1 = origin;
        this.y5n_1 = call;
      }
      f5m() {
        return this.y5n_1;
      }
      ww() {
        return this.x5n_1.ww();
      }
      g5m() {
        return this.x5n_1.g5m();
      }
      h5m() {
        return this.x5n_1.h5m();
      }
      z5l() {
        return this.x5n_1.z5l();
      }
      y2q() {
        return this.x5n_1.y2q();
      }
      e55() {
        return this.x5n_1.e55();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.z5n_1 = call;
        this.a5o_1 = body;
        this.b5o_1 = origin.o5m();
        this.c5o_1 = origin.p5m();
        this.d5o_1 = origin.q5m();
        this.e5o_1 = origin.r5m();
        this.f5o_1 = origin.e55();
        this.g5o_1 = origin.ww();
      }
      f5m() {
        return this.z5n_1;
      }
      o5m() {
        return this.b5o_1;
      }
      p5m() {
        return this.c5o_1;
      }
      q5m() {
        return this.d5o_1;
      }
      r5m() {
        return this.e5o_1;
      }
      e55() {
        return this.f5o_1;
      }
      ww() {
        return this.g5o_1;
      }
      n5m() {
        return ByteReadChannel(this.a5o_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1hc0jjdmqj6mp,
  SavedHttpResponse as SavedHttpResponsendyse4i0h687,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
